import React from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import ParameterFormatter from '../ParameterFormatter';

const Date1Type = ({question, intl}) => (
    <>
        <h4><FormattedMessage {...messages.surveys.form.label.parameterList} /></h4>
        <table className="table table-sm">
            <tbody>
                <tr>
                    <th scope="row"><FormattedMessage {...messages.surveys.form.label.min} /></th>
                    <td><ParameterFormatter value={intl.formatDate(question.min)} /></td>
                </tr>
                <tr>
                    <th scope="row"><FormattedMessage {...messages.surveys.form.label.max} /></th>
                    <td><ParameterFormatter value={intl.formatDate(question.max)} /></td>
                </tr>
            </tbody>
        </table>
    </>
);

export default injectIntl(Date1Type);
